import { render, staticRenderFns } from "./TermsCreate.vue?vue&type=template&id=71779566&"
import script from "./TermsCreate.vue?vue&type=script&lang=js&"
export * from "./TermsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports